var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosGoogleMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:google-meet",
    clipPath: "url(#clip0_30_5485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5898 14.9747L24.1382 19.0307L28.9101 22.0798L29.7401 15.0003L28.9101 8.08057L24.0468 10.7591L20.5898 14.9747Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 21.4208V27.4535C0 28.831 1.1181 29.9494 2.49583 29.9494H8.52853L9.77773 25.3912L8.52853 21.4208L4.38967 20.1716L0.00014218 21.4208H0Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.52853 0L0 8.52853L4.38995 9.77474L8.52853 8.52853L9.75498 4.61218L8.52853 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 21.4235H8.52839V8.52832H0V21.4235Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.3584 3.61115L28.9102 8.08072V22.0798L34.3808 26.5667C35.1998 27.2082 36.3978 26.6236 36.3978 25.5825V4.57542C36.3978 3.52286 35.1712 2.94106 34.3582 3.61129",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.5916 14.9746V21.4208H8.5293V29.9493H26.4161C27.7938 29.9493 28.9118 28.8309 28.9118 27.4535V22.0796L20.5916 14.9746Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.4161 0H8.5293V8.52853H20.5916V14.9747L28.912 8.08038V2.49597C28.912 1.11825 27.7938 0.00014218 26.4161 0.00014218",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_5485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.3981,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleMeet);
export default __webpack_public_path__ + "static/media/logos_google_meet.850844409ad60e785e982dc886cb4282.svg";
export { ForwardRef as ReactComponent };